export const US_CONFIG = {
  code: 'US',
  name: 'United States',
  locale: 'en-US',
  currency: {
    code: 'USD',
    symbol: '$',
    format: 'en-US'
  },
  address: {
    format: 'US',
    hasStateField: true, // US requires state field
    postalCodePattern: /^\d{5}$/,
    regionCode: 'US',
    requiredFields: ['line1', 'city', 'state', 'zipcode'],
    labels: {
      state: 'State',
      zipcode: 'Zip Code',
      line1: 'Address Line 1',
      line2: 'Address Line 2',
      city: 'City'
    },
    placeholders: {
      line1: 'Enter street address',
      line2: 'Apt, suite, etc. (optional)',
      city: 'Enter city',
      zipcode: 'Enter ZIP code'
    }
  },
  enableViewPlancard: true,
  genderList: [
    {
      key: 'Male',
      value: 'Male',
    },
    {
      key: 'Female',
      value: 'Female',
    },
    {
      key: 'Others',
      value: 'Other',
    },
  ],
  phone: {
    pattern: /^\+?1?[-.\s]?\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$/,
    format: '(XXX) XXX-XXXX',
    placeholder: '(555) 123-4567',
    countryCode: '+1'
  },
  validation: {
    zipcode: {
      pattern: /^\d{5}$/,
      message: 'Please enter a valid ZIP code (e.g., 12345)'
    },
    phone: {
      pattern: /^\+?1?[-.\s]?\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$/,
      message: 'Please enter a valid US phone number'
    }
  },
  dateFormat: {
    short: 'MM/DD/YYYY',
    long: 'MMM DD, YYYY',
    display: 'en-US'
  },
  minorAge: 16, // Age below which a responsible party is required
  stripeSecretKey: process.env.REACT_APP_STRIPE_SECRET_KEY,
  terminal: {
    enabled: true,
  },
  zendeskKey: '4c39cfcb-472c-44e1-9d54-a12c20201beb',
};
